import { Model } from "@ofqual/portal-core/core/types";

export type ReportConfig = {
  reportId: string;
  workspaceId: string;
  objectType: string;
  displayName: string;
  description: string;
  reportGroupDisplayName: string;
  reportGroupDescription: string;
  customReportFilters: string;
  customReportSettings: string;
  recognitionNumber: string;
};

export const fromApiModel = (model: Model): ReportConfig => {
  return {
    reportId: model.ReportId,
    workspaceId: model.WorkspaceId,
    objectType: model.ObjectType,
    displayName: model.DisplayName,
    description: model.Description,
    reportGroupDisplayName: model.ReportGroupDisplayName,
    reportGroupDescription: model.ReportGroupDescription,
    customReportFilters: model.CustomReportFilters,
    customReportSettings: model.CustomReportSettings,
    recognitionNumber: model.RecognitionNumber,
  };
};

export const toApiModel = (item: ReportConfig): Model => {
  return {
    ...item,
  } as Model;
};
